export const FeatureFlag = {
  katalLogger: true,
  katalLoggerSuccessLogging: true,
};
